import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { FeaturedCompanions } from './components/FeaturedCompanions';
import { WhyChooseUs } from './components/WhyChooseUs';
import { MembershipSection } from './components/MembershipSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-bg text-gray-200 font-sans selection:bg-gold-500 selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ServicesSection data-id="element-2" />
      <FeaturedCompanions data-id="element-3" />
      <WhyChooseUs data-id="element-4" />
      <MembershipSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <ContactSection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}